<template>
  <div class="container">
    <div class="header-img">
      <img src="../../assets/images/drugcoupon/header.png" alt="">
    </div>
    <div class="content-wrapper">
      <div class="content">
        <div v-if="isShow === 0">
          <div class="coupon-img">
            <img src="../../assets/images/drugcoupon/juan.png" alt="">
          </div>
          <div class="form-item form-item-button">
            <button class="form-button" type="submit" @click="getCouponList">立即领取</button>
          </div>
        </div>
        <div v-if="isShow === 1">
          <div class="phone-desc">
            <!-- <p class="desc-1">恭喜您！领取成功</p> -->
            <p class="desc-2" v-if="phone">当前领取账户：{{phone}}</p>
          </div>
          <div class="coupon-img">
            <img src="../../assets/images/drugcoupon/juanyou.png" alt="">
          </div>
          <div class="form-item form-item-button">
            <button class="form-button" type="submit" @click="getUse">立即使用</button>
          </div>
        </div>
        </div>
      <rule-page></rule-page>
    </div>
  </div>
</template>
<script>
import { Toast, Divider } from 'vant'
import { getCoupon, haveCoupon, getTaskUrl } from '@/api/drugCoupon'
import RulePage from './rule'
import { setStore, getStore } from '@/utils/index'

export default {
  components: {
    [Divider.name]: Divider,
    RulePage: RulePage
  },
  data () {
    return {
      isShow: 0,
      phone: null,
      token: ''
    }
  },
  created () {
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
      this.getIsCoupon()
    }
  },
  methods: {
    getPhone (phone) {
      let reg = /^(\d{3})\d*(\d{4})$/
      if (!phone) {
        return null
      }
      return phone.replace(reg, '$1****$2')
    },
    getIsCoupon () {
      const { activityId, batchId } = this.$route.query
      const requestData = {
        activityId: activityId,
        batchId: batchId
      }
      haveCoupon(requestData).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          const data = res.data.result
          if (data) {
            this.isShow = data.state
            this.phone = data.phone
          }
        } else {
          Toast({
            message: res.data.message
          })
        }
      })
    },
    getCouponList () {
      const { activityId, batchId } = this.$route.query
      const requestData = {
        activityId: activityId,
        batchId: batchId
      }
      getCoupon(requestData).then((res) => {
        if (res.data.code === 200) {
          const state = res.data.result.state
          const token = getStore('token')
          this.$router.push({ path: '/drugAppSuc', query: { phone: this.phone, state: state, token: token } })
        } else {
          Toast({
            message: res.data.message
          })
        }
      })
    },
    getUse () {
      const appId = '20130'
      getTaskUrl(appId).then((res) => {
        const data = res.data.result
        if (data) {
          // 跳转到原生界面
          // eslint-disable-next-line no-undef
          dsBridge.call('callNativeViewLifeCycle', {
            androidGoPage: data.androidGoPage,
            iosGoPage: data.iosGoPage,
            appId: data.appId,
            appType: data.appType,
            appStartUrl: data.appStartUrl,
            authorize: 0,
            addToolbar: 1
          })
        } else {
          console.log('其他')
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  min-height: 100vh;
  background: #f8f8f8;
}
.header-img {
  img {
    width: 100%;
  }
}
.coupon-img {
  height: 80px;
  max-width: 310px;
  margin: 20px auto 5px;
  text-align: center;
  img {
    width: 100%;
  }
}
.content {
  position: relative;
  margin: -30px 15px 15px 15px;
  padding: 18px 15px 5px 15px;
  border-radius: 10px;
  background: #fff;
  z-index: 100;
}
.custom-form {
  margin: 10px 0 20px;
  padding: 6px 0;
  border-radius: 10px;
  background: #f8f8f8;
}
.form-item {
  display: flex;
  align-items: center;
  margin:  10px 15px;
  border-radius: 5px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 15px 0  15px;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  margin-bottom: 10px;
  background-color: #FE4C31;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    line-height: 30px;
  }
}
.form-title {
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
}
.form-item-rule {
  margin: 0 auto;
  font-size: 15px;
  color: #666;
  text-align: center;
}
.form-control {
  width: 100%;
  background: #E4E4E4;
  padding: 8px 12px;
  border-radius: 5px;
}
.form-control.form-invite {
  font-size: 15px;
}
.form-input {
  width: 100%;
  height: 100%;
  background: #E4E4E4;
  outline: none;
  font-size: 15px;
}
.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto;
  padding: 8px 5px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  outline: none;
  background-color: #4E73F4;
}
.form-down {
  position: absolute;
  right: 11%;
  text-align: center;
  background: #fff;
  text-decoration: underline;
  color: #666;
  font-size: 12px;
}
.form-code-item {
  background: #E4E4E4;
}
.form-code-line {
  background: #aaa;
  height: 12px;
  width: 1px;
  margin: 0 3px;
}
.form-code-btn {
  margin-left: 8px;
  padding: 8px 10px;
  height: 100%;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 14px;
  color:#4E73F4;
  line-height: 1;
  outline: none;
  background: #e4e4e4;
}
.form-code-btn:disabled {
  color: #FE4C31;
}
.rule-wrapper {
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
}
.rule-content {
  padding: 0 15px 15px 15px;
  background: #fff;
  border-radius: 10px;
}
.rule-item {
  .title {
    font-size: 14px;
    margin: 15px 0 6px;
    color: #282828;

  }
  .desc {
    line-height: 1.6;
    font-size: 12px;
    color: #999;
  }
}
.phone-img {
  margin: 20px auto 20px;
  width: 70px;
}
.phone-desc {
  line-height: 1.6;
  text-align: center;
}
.coupon-img {
  height: 80px;
  max-width: 310px;
  margin: 20px auto 5px;
  text-align: center;
}
.desc-1 {
  margin-bottom: 3px;
  font-size: 18px;
  color: #4E73F4;
}
.desc-2 {
  padding: 0 15px;
  font-size: 14px;
  color: #282828;
}

</style>
